/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	WhatsAppTemplateUpdatePathParams,
	WhatsAppTemplateUpdateRequest,
	WhatsAppTemplateUpdateResponse,
} from '../types/WhatsAppTemplateUpdate'

/**
 * PATCH /organisations/:organisationId/whatsapp-templates/:templateId
 * @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppTemplateController.php WhatsAppTemplateController::update
 */
export async function whatsAppTemplateUpdate(
	organisationId: WhatsAppTemplateUpdatePathParams['organisationId'],
	templateId: WhatsAppTemplateUpdatePathParams['templateId'],
	data: WhatsAppTemplateUpdateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<WhatsAppTemplateUpdateResponse>> {
	return axiosInstance.patch(`/organisations/${organisationId}/whatsapp-templates/${templateId}`, data, config)
}
